import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=2d00dcf0&scoped=true&lang=pug"
import script from "./StatusBadge.vue?vue&type=script&lang=js"
export * from "./StatusBadge.vue?vue&type=script&lang=js"
import style0 from "./StatusBadge.vue?vue&type=style&index=0&id=2d00dcf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00dcf0",
  null
  
)

export default component.exports